import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    openUploadE7,
    closeUploadE7
} from '../../reducers/modals.js';
import { Icon } from 'antd';

import folderIcon from './folder.svg';
import pythonIcon from './Python.svg';
import MP3Icon from './MP3.svg';
import imageIcon from './image.svg';
import videoIcon from './video.svg';
import errIcon from './err.svg';

if (window.require != undefined) {
    var ipcRenderer = window.require('electron').ipcRenderer;
}

import styles from './upload_E7.module.css';

class Upload_E7 extends Component {
    constructor(props) {
        super(props)
        this.state = {
            dirList: [],
            isload: false,
            loadTitle: '上传中...，请稍等'
        }
        this.handleClose = this.handleClose.bind(this)
        this.updateList = this.updateList.bind(this)
        this.handledrop = this.handledrop.bind(this)
        this.handledragover = this.handledragover.bind(this)
        this.handleContextMenu = this.handleContextMenu.bind(this)
        this.handleCancelContext = this.handleCancelContext.bind(this)
        this.handleRemoveFile = this.handleRemoveFile.bind(this)
    }
    componentDidMount() {
        ipcRenderer && ipcRenderer.on('getDirList', (event, arg) => {
            if (Array.isArray(arg)) {
                let dirLists = this.setImageList(arg)
                this.setState({
                    dirList: dirLists,
                    isload: false
                })
            }
        })
        ipcRenderer && ipcRenderer.on('closeLoad', (event, arg) => {
            this.setState({
                isload: arg
            })
        })
        this.updateList()
    }
    componentWillUnmount() {
        ipcRenderer && ipcRenderer.removeAllListeners('getDirList')
        ipcRenderer && ipcRenderer.removeAllListeners('closeLoad')
    }
    updateList() {
        try {
            ipcRenderer && ipcRenderer.send('updateDirList')
        } catch (err) {
            console.log(err)
        }
    }
    setImageList(list) {
        return list.map((item, index) => {
            let ext = item.split('.')[1]
            if (ext) {
                if (ext === 'py') {
                    return { value: item, img: pythonIcon }
                } else if (ext === 'jpeg' || ext === 'png' || ext === 'jpg') {
                    return { value: item, img: imageIcon }
                } else if (ext === 'mp4') {
                    return { value: item, img: videoIcon }
                } else if (ext === 'mp3') {
                    return { value: item, img: MP3Icon }
                } else {
                    return { value: item, img: errIcon }
                }
            }
        })
    }
    handleClose(e) {
        if (this.state.isload) {
            return
        }
        let close = e.target.getAttribute('data-close')
        if (close) {
            if (this.props.isUploadE7) {
                this.props.setUploadE7(false)
            } else {
                this.props.setUploadE7(true)
            }
        }
    }
    handledrop(e) {
        e.preventDefault()
        let files = e.dataTransfer.files
        let uploadList = []
        for (let i = 0; i < files.length; i++) {
            uploadList.push(files[i].path)
        }
        try {
            ipcRenderer && ipcRenderer.send('uploadFile', uploadList)
            ipcRenderer && this.setState({
                isload: true,
                loadTitle: '上传中...，请稍等'
            })
        } catch (err) {
            console.log(err)
        }
    }
    handledragover(e) {
        e.preventDefault()
    }
    handleCancelContext(e) {
        this.menuContext && (this.menuContext.style = '')
        document.removeEventListener('click', this.handleCancelContext)
    }
    handleContextMenu(e, fileName) {
        e.preventDefault()
        this.fileName = fileName
        // this.menuContext
        this.menuContext && this.menuContext.setAttribute('style', `
            display:block;
            left:${e.nativeEvent.clientX}px;
            top:${e.nativeEvent.clientY}px;
        `)
        document.addEventListener('click', this.handleCancelContext)
    }
    handleRemoveFile() {
        if (!this.fileName) {
            return
        }
        try {
            ipcRenderer && ipcRenderer.send('removeFile', this.fileName)
            ipcRenderer && this.setState({
                isload: true,
                loadTitle: '正在删除文件...'
            })
        } catch (err) {
            console.log(err)
        }
    }
    render() {
        return (
            <div className={styles.containers} onClick={this.handleClose} data-close={true}>
                <div className={styles.uploadE7_library}>
                    <div className={styles.libraryTitle}>
                        资源管理
                    </div>
                    <div id='drag' className={styles.drag}
                        onDrop={this.handledrop}
                        onDragOver={this.handledragover}
                        onContextMenu={(e) => { e.preventDefault() }}
                    >
                        {
                            this.state.dirList.length === 0 ? (
                                <div className={styles.NoData}>空列表</div>
                            ) : (
                                <div className={styles.dragContainer}>
                                    {this.state.dirList.map((item, index) => (
                                        <p className={styles.fileItem} key={index}
                                            onContextMenu={(e) => { this.handleContextMenu(e, item.value) }}
                                        >
                                            <img src={item.img} alt="" draggable={false} />
                                            <i>{item.value}</i>
                                        </p>
                                    ))}
                                </div>
                            )
                        }
                    </div>
                    <div className={styles.comfirmBox}>
                        <button id="closeRobot"
                            className={styles.btnClose}
                            data-close={true}
                        >
                            关闭
                        </button>
                    </div>
                    {
                        this.state.isload ? (<div className={styles.upload_loading}>
                            <div>
                                <Icon type="upload" style={{ color: '#fff', fontSize: '10rem' }} />
                                <p>{this.state.loadTitle}</p>
                            </div>
                        </div>) : null
                    }

                </div>

                <div className={styles.itemContext}
                    ref={(e) => {
                        this.menuContext = e
                    }}
                    onContextMenu={(e) => { e.preventDefault() }}
                >

                    <p style={{ color: 'red' }} onClick={this.handleRemoveFile}>删除</p>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state, props) => ({
    isUploadE7: state.scratchGui.modals.uploadE7
})

const mapDispatchToProps = (dispatch) => ({
    setUploadE7: (open) => {
        if (open) {
            dispatch(openUploadE7(open))
        } else {
            dispatch(closeUploadE7(open))
        }
    }
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Upload_E7)